import React from "react"
import { useTranslation } from "react-i18next"

import dateService from "services/date"
import { HistoryTable } from "."
import { historyTypes, ONE_DAY_IN_SECONDS } from "utils/constants"

const WAITING = "waiting"
const EXPIRED = "expired"

export const HistorySubFilters = ({ data, filters, bikeType }) => {
    const defaultAllValue = filters[0].value
    const isOnGoingSection = bikeType === historyTypes.onGoing.value

    const [selectedFilterStatus, setSelectedFilterStatus] = React.useState(defaultAllValue)
    const [filteredData, setFilteredData] = React.useState(data)
    const { t } = useTranslation()

    React.useEffect(() => {
        setFilteredData(data)
    }, [data])

    const getExpiredDate = (date) => {
        return dateService.getTimestamp(date) + ONE_DAY_IN_SECONDS
    }

    React.useEffect(() => {
        // We filter each bike with the name of the operation
        const bikesList = data.filter(bike => [...selectedFilterStatus].includes(bike?.operation))

        // Special case for "onGoing" Section
        if (isOnGoingSection) {
            // We need to filter bikes between "waiting" and "expired" requests
            // If a request exceeds 24 hours, we need to pass this request in "expired" filter
            const selectedStatus = filters.find(filter => filter.value === selectedFilterStatus)

            if (selectedStatus.id === WAITING || selectedStatus.id === EXPIRED) {
                const now = new Date().getTime()

                const updatedList = bikesList
                    .map((bike) => ({ ...bike, expiredDate: getExpiredDate(bike?.create_date) }))
                    .filter(bike => selectedStatus.id === EXPIRED ? now > bike.expiredDate : now < bike.expiredDate)

                setFilteredData(updatedList)
            } else {
                setFilteredData(bikesList)
            }
        } else {
            setFilteredData(bikesList)
        }

    }, [selectedFilterStatus]) // eslint-disable-line

    return (
        <>
            <div className="c-history__filters mb-5">
                {filters && filters.map((item, i) => (
                    <button
                        type="button"
                        key={i}
                        value={item.value}
                        className={`mx-2 ${item.value === selectedFilterStatus ? "is-active" : ""}`}
                        onClick={() => setSelectedFilterStatus(item.value)}
                    >
                        {t(`${item.label}`)}
                    </button>
                ))}
            </div>

            {filteredData &&
                <HistoryTable
                    data={filteredData}
                    bikeType={bikeType}
                    className="pb-7"
                />
            }
        </>
    )
}